export const appBuildAssetsDir = "/_nuxt/releases/2b078d12-3f83-41c9-844d-074daa35e71a/"

export const appHead = {"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"https://storage.cromi.ru/favicons/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://storage.cromi.ru/favicons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://storage.cromi.ru/favicons/favicon-16x16.png"},{"rel":"manifest","href":"https://storage.cromi.ru/favicons/site.webmanifest"},{"rel":"mask-icon","href":"https://storage.cromi.ru/favicons/safari-pinned-tab.svg","color":"#5bbad5"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"msapplication-TileColor","content":"#f31a34"},{"name":"theme-color","content":"#ffffff"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"titleTemplate":"%s","htmlAttrs":{"class":"scroll-smooth","lang":"ru"}}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","externalRelAttribute":"noopener noreferrer","activeClass":"router-link-active","exactActiveClass":"router-link-exact-active","trailingSlash":"append","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true